<template>
  <div>
    <div v-if="!enterOneTimePass">
      <v-row>
        <v-text-field
          v-model="phone"
          :label="$t('loginSMS.yourPhoneNumber')"
          outlined
          type="number"
          autocomplete="tel"
          prepend-icon="mdi-phone"
          placeholder="380991234567"
        >
        </v-text-field>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-btn color="primary" @click="getOneTimePass"
          >{{ $t('loginSMS.getOneTimePassword') }}</v-btn
        >
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-text-field
          v-model="oneTimePass"
          :label="$t('loginSMS.enterOneTimePassword')"
          outlined
          type="number"
          prepend-icon="mdi-android-messages"
        >
        </v-text-field>
      </v-row>
      <v-row class="d-flex justify-space-between">
        <v-btn color="primary" @click="enterOneTimePass = false">
          <v-icon left dark> mdi-arrow-left </v-icon>
          {{ $t('loginSMS.back') }}
        </v-btn>
        <v-btn color="primary" @click="sendOneTimePass">{{ $t('loginSMS.send') }}</v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
import uk from '../../langs/loginSMS/uk.json'
import ru from '../../langs/loginSMS/ru.json'
import en from '../../langs/loginSMS/en.json'
export default {
  name: 'dr-login-sms-component',
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  },
  data: () => ({
    phone: '',
    enterOneTimePass: false,
    oneTimePass: ''
  }),
  methods: {
    async getOneTimePass() {
      const response = await this.$authCore.SignInSendSMS({
        phone: this.phone
      })

      if (!response.success) {
        return
      }
      this.enterOneTimePass = true
    },
    async sendOneTimePass() {
      await this.$authCore.SignInSendOneTimePass({
        pass: this.oneTimePass
      })
    }
  }
}
</script>